// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3H9UL","name":"ConsentHeader_name__l1eCA","birthday":"ConsentHeader_birthday__1QVoe","skeleton":"ConsentHeader_skeleton__r4PLA"};